import React, { Component } from "react";
import Image from '../global/Image';

export default class InfoAbout extends Component {
  	
  	constructor(){
		super()
		this.state = {
			open:false,
			maxHeight: 0,
			animate:false
		}
		this.handleResize = this.handleResize.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
	}
    
	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	  	setTimeout(() => {
		  	this.handleResize();
		}, 10);
		setTimeout(() => {
		  	this.handleResize();
		}, 100);
		setTimeout(() => {
		  	this.handleResize();
		}, 250);
		setTimeout(() => {
		  	this.handleResize();
		}, 500);
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
    
    handleToggle(_el) {  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    } else {
		    this.setState({ open : true });
	    }
	    setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
    }
        
    handleResize() {
	  	if (this.longText && this.state.open === true) {
	  		this.setState({maxHeight : this.longText.clientHeight});
  		} else if (this.shortText) {
	  		this.setState({maxHeight : this.shortText.clientHeight});
  		}
  	}
  	
	render() {
		
		const post = this.props.post; 
		
		if (post.about) {
			
			let stateClass = '';
			if (this.state.open) {
				stateClass = ' state-open';
			}
			if (this.state.animate) {
				stateClass = stateClass + ' state-animate';
			}
		
			return (
				
				<div className="c-info__section c-load">
				
					<div className="l-content">
				
						<div className="l-grid">
						
							<div className="l-grid__col">
								
								<div className={'c-more-text ' + stateClass} style={{height:this.state.maxHeight+'px'}}>
									
									<div className="c-more-text__short scope-text scope-text--small" ref={e => (this.shortText = e)} dangerouslySetInnerHTML={{__html:post.about}}></div>
									
									<div className="c-more-text__long scope-text scope-text--small" ref={e => (this.longText = e)} dangerouslySetInnerHTML={{__html:post.about_more}}></div>
								
								</div>
								
								{this.state.open &&
									<p onClick={this.handleToggle} className="c-more-text__toggle">Less</p>
								}
								{!this.state.open &&
									<p onClick={this.handleToggle} className="c-more-text__toggle">More</p>
								}
								
							</div>
						
						</div>
						
					</div>
				
				</div>
				
			)
			
		} else {
			
			return false;
			
		}
		
	}
							
}